// extracted by mini-css-extract-plugin
module.exports = {"back-button":"_1QFaXXehc9YBGoI_a9YS4x"};